import { render, staticRenderFns } from "./OrderEvents.vue?vue&type=template&id=258e1146&"
import script from "./OrderEvents.vue?vue&type=script&lang=js&"
export * from "./OrderEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports